import { render } from "./MosnitaView.vue?vue&type=template&id=3699683f"
const script = {}

import "./MosnitaView.vue?vue&type=style&index=0&id=3699683f&lang=css"

import exportComponent from "D:\\Backup\\Sunville\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__